import React from "react";
import "./App.css";
import "./index.css";

import { Route, Routes } from "react-router-dom";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import Home from "./components/home/Home";
import Thank_you from "./components/thank-you/Thank_you";
import WhatsappChatbot from "./components/chatbot/Chatbot";

function App() {
  return (
    <>
      {/* <ScrollToTop /> */}
      <Header />
      <WhatsappChatbot />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/thank-you" element={<Thank_you />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
